import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
import { BillingCartProvider } from './context/BillingCartContext';
import { ViewModeProvider } from './context/ViewModeContext';
render(<ViewModeProvider data-id="element-1746">
    <BillingCartProvider data-id="element-1747">
      <AppRouter data-id="element-1748" />
    </BillingCartProvider>
  </ViewModeProvider>, document.getElementById('root'));